import { render, staticRenderFns } from "./middle.vue?vue&type=template&id=b1edef82&scoped=true"
import script from "./middle.vue?vue&type=script&lang=js"
export * from "./middle.vue?vue&type=script&lang=js"
import style0 from "./middle.vue?vue&type=style&index=0&id=b1edef82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1edef82",
  null
  
)

export default component.exports